module.exports = ["2011","2012","2013","2014","2015","2016","2017","2018"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/years_acm.json
// module id = jaQa
// module chunks = 1